import config from "config";

export const enMessage = async () => {
    const respone = await fetch(`${config.api.languageUrl}english.json`, {
        method: 'GET',
        headers: {
            "Content-Type": "application/octet-stream"
        }
    });

    const json = respone.json();

    return json
}